import React from 'react';

const DiscountValue = props => {
  return (
    <div className="PlanDetailDiscountValue" >
      {`毎月 ${props.value}円 割引`}<br />
      （{`税込 ${props.valueWithTax}円 割引`}）
    </div>
  );
};

export default DiscountValue;
